<template>
  <div>
  <multi-select
    v-model="value"
    :options="items"
    :taggable="true"
    :multiple="true"
    label="label"
    track-by="id"
    @tag="addTag"
    @input="changed"
  />
  </div>
</template>

<script>
import { HTTPAUTH } from "../lib/httplib";
import MultiSelect from 'vue-multiselect';
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  components: {
    MultiSelect,
  },
  name: "EntranceMajorMulti",
  data() {
    return {
      items: [],
    };
  },
  props: ["value"],
  created() {
    this.init("");
  },
  methods: {
    init(q) {
      HTTPAUTH.get(`/api/v1/entrance-major?q=${q}`).then((res) => {
        this.items = res.data.data;
      });
    },
    getOptions(search, loading) {
      loading(true);
      this.init(search);
      loading(false);
    },
    changed(data) {
      this.$emit("input", data);
    },
    addTag(newTag) {
      console.log(newTag)
    }
  },
};
</script>

<style scoped>
</style>
